import { PLATFORMS } from '@/data/siteData'
import PlatformCard from '@/components/PlatformCard/PlatformCard'
import PlatformDetail from '@/components/PlatformDetail/PlatformDetail'
import StatsBand from '@/components/StatsBand/StatsBand'
import CtaSection from '@/components/CtaSection/CtaSection'
import styles from './PlatformPage.module.css'

const platform = PLATFORMS.find(p => p.id === 'promptnexus')

const HOW_TO_WIN = [
  { num: '01', title: 'Browse Challenges', desc: 'Explore active hackathons, prompt challenges, and industry competitions on the dashboard.' },
  { num: '02', title: 'Register & Form a Team', desc: 'Sign up solo or form a team of up to 4. Diverse skills win more challenges.' },
  { num: '03', title: 'Build & Submit', desc: 'Use the provided tools and submit your solution before the deadline.' },
  { num: '04', title: 'Get Judged', desc: 'Real judges — industry experts and partner companies — evaluate your submission.' },
  { num: '05', title: 'Win Rewards', desc: 'Top performers earn NexusCoins, certificates, and visibility to hiring partners.' },
]

export default function PromptNexusPage() {
  return (
    <>
      {/* ── PAGE HERO ── */}
      <section className={styles.hero} aria-label="PromptNexus hero">
        <div
          className={styles.heroBg}
          style={{ background: 'radial-gradient(ellipse 80% 60% at 50% -10%, rgba(28,45,94,0.4) 0%, transparent 70%), radial-gradient(ellipse 40% 40% at 80% 80%, rgba(232,100,42,0.12) 0%, transparent 60%)' }}
          aria-hidden="true"
        />
        <div className={styles.heroContent}>
          <span
            className={styles.heroBadge}
            style={{ background: platform.colorBg, border: `1px solid ${platform.colorBorder}`, color: platform.color }}
          >
            <span className={styles.badgeDot} style={{ background: platform.dotColor }} />
            AI Challenge Platform — Now Open
          </span>
          <h1 className={styles.heroTitle}>
            <span className="grad">PromptNexus</span>
          </h1>
          <p className={styles.heroSub}>
            Compete. Innovate. Get noticed. The platform where AI skills meet
            real-world challenges — and the best minds rise to the top.
          </p>
          <div className={styles.heroActions}>
            <a href="https://pn.nexusaiweb.com" target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-lg">
              Join a Challenge
            </a>
            <a href="https://pn.nexusaiweb.com" target="_blank" rel="noopener noreferrer" className="btn btn-ghost btn-lg">
              Host a Hackathon
            </a>
          </div>
        </div>
      </section>

      {/* ── PLATFORM CARD ── */}
      <section className={styles.cardSection} aria-label="PromptNexus details">
        <PlatformCard platform={platform} />
      </section>

      {/* ── DEEP DIVE: overview, stats, pillars, journey, audience, FAQ ── */}
      <PlatformDetail id="promptnexus" />

      {/* ── HOW TO WIN ── */}
      <section className={styles.featuresSection} aria-label="How PromptNexus works">
        <div className={styles.featuresInner}>
          <p className="section-label">How It Works</p>
          <h2 className="section-title">From zero to winner in 5 steps</h2>
          <div className={styles.howSteps}>
            {HOW_TO_WIN.map(({ num, title, desc }) => (
              <div key={num} className={styles.howStep}>
                <span className={styles.howNum}>{num}</span>
                <div className={styles.howIcon} style={{ background: 'rgba(232,100,42,0.12)' }}>🎯</div>
                <h3 className={styles.featTitle}>{title}</h3>
                <p className={styles.featDesc}>{desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── STATS ── */}
      <StatsBand />

      {/* ── CTA ── */}
      <CtaSection
        label="Start Competing"
        title={'Join your first\nAI hackathon today'}
        sub="Show the world what you can build. Earn rewards. Get noticed."
        ctaText="Browse Open Challenges"
        ctaHref="https://pn.nexusaiweb.com"
      />
    </>
  )
}
